/* tslint:disable */
/* eslint-disable */
/**
 * Vocalise.API.Web
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  FAnonymousType104,
  FAnonymousType91,
  MeasurementDTO,
} from '../models/index';
import {
    FAnonymousType104FromJSON,
    FAnonymousType104ToJSON,
    FAnonymousType91FromJSON,
    FAnonymousType91ToJSON,
    MeasurementDTOFromJSON,
    MeasurementDTOToJSON,
} from '../models/index';

export interface ApiMeasurementIdGetRequest {
    id: number;
}

export interface ApiMeasurementIdRecordingGetRequest {
    id: number;
}

export interface ApiMeasurementPostRequest {
    measurementDTO: MeasurementDTO;
}

/**
 * 
 */
export class MeasurementApi extends runtime.BaseAPI {

    /**
     */
    async apiMeasurementGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<FAnonymousType104>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/measurement`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(FAnonymousType104FromJSON));
    }

    /**
     */
    async apiMeasurementGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<FAnonymousType104>> {
        const response = await this.apiMeasurementGetRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async apiMeasurementIdGetRaw(requestParameters: ApiMeasurementIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MeasurementDTO>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling apiMeasurementIdGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/measurement/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MeasurementDTOFromJSON(jsonValue));
    }

    /**
     */
    async apiMeasurementIdGet(requestParameters: ApiMeasurementIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MeasurementDTO> {
        const response = await this.apiMeasurementIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiMeasurementIdRecordingGetRaw(requestParameters: ApiMeasurementIdRecordingGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling apiMeasurementIdRecordingGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/measurement/{id}/recording`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiMeasurementIdRecordingGet(requestParameters: ApiMeasurementIdRecordingGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiMeasurementIdRecordingGetRaw(requestParameters, initOverrides);
    }

    /**
     */
    async apiMeasurementPostRaw(requestParameters: ApiMeasurementPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FAnonymousType91>> {
        if (requestParameters['measurementDTO'] == null) {
            throw new runtime.RequiredError(
                'measurementDTO',
                'Required parameter "measurementDTO" was null or undefined when calling apiMeasurementPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/measurement`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: MeasurementDTOToJSON(requestParameters['measurementDTO']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FAnonymousType91FromJSON(jsonValue));
    }

    /**
     */
    async apiMeasurementPost(requestParameters: ApiMeasurementPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FAnonymousType91> {
        const response = await this.apiMeasurementPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
